import React, { useEffect, useState } from 'react';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import firebase from '../db/firebase'; // Asegúrate de que esté bien importado

const AppSettings = () => {
  const [limitActive, setLimitActive] = useState(false);
  const [limitWithdraw, setLimitWithdraw] = useState(0); // £ mínimo
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const docRef = doc(firebase.db, 'administratorSettings', 'withdrawMoney');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data() || {};
          setLimitActive(Boolean(data.limitActive));
          // si viene null/NaN, dejamos 0
          const parsed = Number.isFinite(Number(data.limitWithdraw))
            ? Number(data.limitWithdraw)
            : 0;
          setLimitWithdraw(Math.max(0, Math.floor(parsed)));
        }
      } catch (err) {
        console.error('Error fetching settings:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const persist = async (payload) => {
    try {
      setSaving(true);
      await updateDoc(docRef, payload);
    } catch (err) {
      console.error('Error updating settings:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleToggle = async () => {
    const newValue = !limitActive;
    setLimitActive(newValue);
    await persist({ limitActive: newValue });
  };

  const handleChangeWithdraw = async (e) => {
    // fuerza entero >= 0
    const raw = e.target.value;
    const next = Math.max(0, Math.floor(Number(raw) || 0));
    setLimitWithdraw(next);
    await persist({ limitWithdraw: next });
  };

  if (loading) {
    return (
      <div className="flex-1 h-full flex items-center justify-center bg-white z-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-gray-800"></div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">App Settings</h1>

      <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Withdraw Money</h2>

        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Minimum Withdrawal (£)</label>
          <input
            type="number"
            min={0}
            step={1}
            value={limitWithdraw}
            onChange={handleChangeWithdraw}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
         
        </div>

        <div className="flex items-center gap-3">
          <input
            id="limit-active"
            type="checkbox"
            checked={limitActive}
            onChange={handleToggle}
            className="w-5 h-5"
          />
          <label htmlFor="limit-active" className="text-gray-700">
            Minimum active
          </label>
        </div>

        {saving && (
          <div className="mt-4 text-sm text-teal-700">Saving changes…</div>
        )}

        {!saving && (
          <div className="mt-4 text-sm text-gray-600">
            Current rule:{' '}
            {limitActive
              ? `Minimum ${new Intl.NumberFormat('en-GB', {
                  style: 'currency',
                  currency: 'GBP',
                  maximumFractionDigits: 0,
                }).format(limitWithdraw)}`
              : 'Disabled'}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppSettings;